import createDuck, {createThunk} from '../utils/actions';
import axios from '../net/axios';
import config from '../config';

const baseUrl = config.api.baseUrl;

const feriadosGetDuck = createDuck('FERIADOS_GET');

const feriadosGetThunk = params => {
  const url = `${baseUrl}/v1/feriados`;

  return createThunk(axios, 'get', feriadosGetDuck.actions, url, null, params);
};

const feriadoCreateDuck = createDuck('FERIADO_CREATE');

const feriadoCreateThunk = params => {
  const url = `${baseUrl}/v1/feriado`;

  return createThunk(axios, 'post', feriadoCreateDuck.actions, url, params);
};

const feriadoDeleteDuck = createDuck('FERIADO_DELETE');

const feriadoDeleteThunk = params => {
  const url = `${baseUrl}/v1/feriado`;

  return createThunk(axios, 'delete', feriadoDeleteDuck.actions, url, params);
};

export {
  feriadosGetDuck,
  feriadosGetThunk,
  feriadoCreateDuck,
  feriadoCreateThunk,
  feriadoDeleteDuck,
  feriadoDeleteThunk,
};
